/**
 * Cache-bust an image URL by adding a timestamp parameter
 * This helps ensure SVG images and other cached images load properly
 * 
 * @param url - The image URL to cache-bust
 * @returns The URL with a cachebuster parameter appended
 * 
 * @example
 * cacheBustImageUrl('https://example.com/image.svg')
 * // Returns: 'https://example.com/image.svg?cachebuster=1234567890123'
 * 
 * @example
 * cacheBustImageUrl('https://example.com/image.svg?existing=param')
 * // Returns: 'https://example.com/image.svg?existing=param&cachebuster=1234567890123'
 */
export function cacheBustImageUrl(url: string): string {
  if (!url) return url;
  
  // Get current time in milliseconds (unix timestamp)
  const unixtime = Date.now();
  
  // Check if URL already has query parameters
  const hasQueryParams = url.includes('?');
  
  // Add cachebuster parameter
  const separator = hasQueryParams ? '&' : '?';
  return `${url}${separator}cachebuster=${unixtime}`;
}
